import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  border-radius: 13px;
  width: 350px;
  min-height: 140px;
  white-space: normal;
  border: 1px solid var(--border-color-table);
  border-radius: 13px;
  background: var(--background-table);
  padding: 24px;
  margin: 0.5em;

  @media (max-width: 992px) {
    flex-direction: column-reverse;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`

export const LefContent = styled.div`
  width: 70%;
  min-width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h2 {
    color: var(--text-dark);
    font-size: var(--font-size-xlg);
    font-weight: bold;
    margin-bottom: 4px;
  }

  button {
    color: var(--theme-primary);
    font-size: var(--font-size-sm);
  }

  p {
    color: var(--text-tertiary);
    margin-bottom: 22px;
    word-wrap: break-word;
    font-size: var(--font-size-ssm);
  }

  @media (max-width: 992px) {
    width: 100%;
  }
`

export const RightContent = styled.div`
  width: 30%;
  max-width: 60px;

  @media (max-width: 992px) {
    width: 100%;
  }
`
